<template>
<div class="modal">
  <div class="modal__body dialog-notification__body">
    <div v-if="title" v-html="title" class="dialog-notification__title h2"/>
    <div v-if="message" v-html="message" class="dialog-notification__message h5 semibold"/>
    <div
      v-if="time && redirectLink"
      class="dialog-notification__redirect-notify h5 semibold"
    >
      Через {{ time }} секунды вы будете перенаправлены на телеграм-канал MiaSofia <a :href="redirectLink" target="_blank" rel="nofollow noopener noreferrer">{{ redirectLink }}</a>
    </div>

    <div class="modal__close" @click="stopTimer">
      <img
        src="~/assets/img/svg/common/close.svg"
        alt="закрыть"
      />
    </div>
  </div>
  <div
    class="modal__overlay"
    @click="stopTimer"
  />
</div>
</template>

<script setup lang="ts">
import { useNotificationModal } from '~/composables/useNotificationModal';
import { computed } from 'vue';
const $router = useRouter();

const {
  infoNotificationModal,
  redirectParamsInfoNotificationModal,
  closeNotificationModal
} = useNotificationModal();

const title = computed(() => {
  return infoNotificationModal.value?.title || ""
});
const message = computed(() => {
  return infoNotificationModal.value?.message || ""
});
const redirectLink = computed(() => {
  return redirectParamsInfoNotificationModal.value?.url || ""
});

const time: any = ref(redirectParamsInfoNotificationModal.value?.timeout)
const localTimeOut: any = ref();
const startTimer = function () {
  if (!time.value || !redirectLink.value) {
    return null
  }
  localTimeOut.value = setInterval(() => {
    if (time.value > 0) {
      time.value -= 1;
    } else {
      window.location.assign(redirectLink.value)
      console.log('window.location', window.location)
      stopTimer()
    }
  }, 1000);
}
const stopTimer = function () {
  if (localTimeOut.value) {
    clearInterval(localTimeOut.value);
  }
  closeNotificationModal()
}
onMounted(() => {
  startTimer()
})
</script>

<style scoped lang="scss">
.dialog-notification__body {
  max-width: 550px;
  padding: 40px;

  .modal__close {
    width: 37px;
    height: 37px;
    border-radius: 10px;
    background: #F4F3F1;
  }
}
.dialog-notification__title {
  margin-bottom: 16px;
  color: black;
}
.dialog-notification__redirect-notify {
  color: #989898;
  margin-bottom: 16px;
}
.dialog-notification__message {
  color: #989898;
  margin-bottom: 16px;
}
</style>
